var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "url(#paint0_linear_4243_179457)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6666 29.1666H57.1124C55.2562 29.1666 54.327 31.4104 55.6395 32.7229L58.5124 35.5958L50.1041 44.0041C47.3499 46.7583 45.8333 50.4208 45.8333 54.3166V60.4166H54.1666V54.3145C54.1666 52.6458 54.8166 51.075 55.9958 49.8937L64.4041 41.4854L67.277 44.3583C68.5895 45.6729 70.8333 44.7437 70.8333 42.8875V33.3333C70.8333 31.0312 68.9687 29.1666 66.6666 29.1666Z",
    fill: "#BDCEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1667 33.3333V42.8875C29.1667 44.7437 31.4105 45.6729 32.723 44.3604L35.596 41.4873L44.0042 49.8937C45.1751 51.0666 45.8334 52.6562 45.8334 54.3125V68.75C45.8334 69.9 46.7667 70.8333 47.9167 70.8333H52.0834C53.2334 70.8333 54.1667 69.9 54.1667 68.75V54.3166C54.1667 50.4479 52.6313 46.7395 49.8959 44.0041L41.4876 35.5958L44.3605 32.7229C45.673 31.4104 44.7438 29.1666 42.8876 29.1666H33.3334C31.0313 29.1666 29.1667 31.0312 29.1667 33.3333Z",
    fill: "url(#paint1_linear_4243_179457)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4243_179457",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4243_179457",
    x1: 30.0001,
    y1: 30,
    x2: 53.7501,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.dea5a5804d8c9094174ff15e41a05be6.svg";
export { ForwardRef as ReactComponent };